/** Keep the offer-preview contract: only the literal query value `true` enables preview. */
export function isPreviewQuery(query: Readonly<Record<string, unknown>>): boolean {
  return query.preview === 'true'
}

/**
 * Follows the current URL, so client navigation into or out of preview changes
 * experiment eligibility without touching the SSR-latched `system.previewMode`.
 */
export function isExperimentPreview(state: Pick<App.State, 'router'>): boolean {
  return isPreviewQuery(state.router?.location.query ?? {})
}

/** Existing client_event schema: emitted for preview visits, which have no experiment enrolment. */
export const EXPERIMENT_PREVIEW_CONTEXT_EVENT = {
  subject: 'experiment_context',
  action: 'preview',
  category: 'experiments',
  type: 'nonInteraction',
} as const
